var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-bar"},[_c('div',{staticClass:"title-bar-left"},[_c('div',{staticClass:"left-line"}),_c('div',{staticClass:"title-name"},[_vm._v(" "+_vm._s(_vm.title)+" "),_vm._t("subTitle")],2)]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }